import React from "react";

export default function IconCheckbox({ checked, children, className = "", testId, onChange }) {
  return (
    <label className={`icon-checkbox ${className}`}>
      <input checked={checked} className="icon-checkbox-input" data-testid={testId} type="checkbox" onChange={onChange} />
      <span aria-hidden="true" className={`fa fa-${checked ? "check-square" : "square-o"} icon-checkbox-icon${checked ? " checked" : ""}`} />
      {children}
    </label>
  );
}
